import { Translation } from 'locales/de/translation';

import layout from './layout';
import groupings from './pages/AWPM-FWPM/groupings';
import moduleSelectionLottery from './pages/AWPM-FWPM/moduleSelectionLottery';
import moduleSelections from './pages/AWPM-FWPM/moduleSelections';
import moduleSelectionsDetail from './pages/AWPM-FWPM/moduleSelectionsDetail';
import modules from './pages/AWPM-FWPM/modules';
import selectionNotifications from './pages/AWPM-FWPM/notifications';
import studentView from './pages/AWPM-FWPM/studentView';
import accessHandler from './pages/Access-Handler/accessHandler';
import entitlementGroups from './pages/Access-Handler/entitlementGroups';
import entitlements from './pages/Access-Handler/entitlements';
import permissions from './pages/Access-Handler/permissions';
import roles from './pages/Access-Handler/roles';
import activityLog from './pages/ActivityLog/activityLog';
import customer from './pages/Billing/customer';
import billingFinance from './pages/Billing/finance';
import invoice from './pages/Billing/invoice';
import settings from './pages/Billing/settings';
import eventSettings from './pages/Events/eventSettings';
import events from './pages/Events/events';
import fundingcategories from './pages/Fundings/categories';
import fundings from './pages/Fundings/fundings';
import companyDetailPage from './pages/Jobmarket/companyDetailPage';
import deactivateJobOffers from './pages/Jobmarket/deactivateJobOffers';
import invoices from './pages/Jobmarket/invoices';
import jobOffers from './pages/Jobmarket/jobOffers';
import manageCompanies from './pages/Jobmarket/manageCompanies';
import manageJobOffers from './pages/Jobmarket/manageJobOffers';
import manageJobmarketSettings from './pages/Jobmarket/manageJobmarketSettings';
import myJobOffers from './pages/Jobmarket/myJobOffers';
import studentJobOffers from './pages/Jobmarket/studentJobOffers';
import leihbar from './pages/LeihBar/leihbar';
import leihbarMailSettings from './pages/LeihBar/leihbarMailSettings';
import leihbarOpeningHoursSettings from './pages/LeihBar/leihbarOpeningHoursSettings';
import jobOfferingNotification from './pages/Messaging/jobOfferingNotifications';
import systemNotificationsSettings from './pages/Messaging/systemNotificationsSettings';
import polyas from './pages/Polyas/polyas';
import pricingslots from './pages/PricingTable/pricingslots';
import shibUserList from './pages/Users/shibUserList';
import watchlist from './pages/Watchlist/watchlist';
import articleDetail from './pages/articleDetail';
import articleMessagesSettings from './pages/articleMessagesSettings';
import articles from './pages/articles';
import calendar from './pages/calendar';
import chat from './pages/chat';
import home from './pages/home';
import internationalOffice from './pages/internationalOffice';
import ioSettings from './pages/ioSettings';
import listingDetail from './pages/listingDetail';
import listings from './pages/listings';
import login from './pages/login';
import managePermissionsSettings from './pages/managePermissionsSettings';
import profile from './pages/profile';
import tileSettings from './pages/tileSettings';
import validation from './validation';

const en: Translation = {
  validation,
  services: {
    jobmarket: 'Job Market',
    userservice: 'User Management',
    articles: 'Articles/Calendar',
    bulletinBoard: 'Bulletin Board',
    permissionProvider: 'Permission Management',
    ioservice: 'International Office',
    messaging: 'Notifications',
    notifications: 'Mailservice',
    faculty: ' Faculty',
    campusservice: 'Campus',
    timetableservice: 'Timetable',
    modules: 'Module catalog',
    moduleSelections: 'Module selection',
    unkownService: 'Unkown'
  },
  warnings: {
    serviceNotAvailable: 'Unfortunately, this service is currently not available.'
  },
  pages: {
    home,
    deactivateJobOffers,
    studentJobOffers,
    login,
    manageCompanies,
    jobOffers,
    articles,
    articleDetail,
    manageJobOffers,
    companyDetailPage,
    myJobOffers,
    manageJobmarketSettings,
    listings,
    calendar,
    managePermissionsSettings,
    listingDetail,
    invoices,
    billingCustomer: customer,
    billingSettings: settings,
    billingFinance,
    articleMessagesSettings,
    profile,
    internationalOffice,
    ioSettings,
    shibUserList,
    polyas,
    systemNotificationsSettings,
    jobOfferingNotification,
    modules,
    moduleSelections,
    moduleSelectionsDetail,
    moduleSelectionLottery,
    groupings,
    selectionNotifications,
    studentView,
    roles,
    permissions,
    accessHandler,
    events,
    eventSettings,
    pricingslots,
    activityLog,
    leihbar,
    leihbarMailSettings,
    leihbarOpeningHoursSettings,
    fundings,
    fundingcategories,
    entitlementGroups,
    entitlements,
    tileSettings,
    watchlist,
    chat,
    billing: invoice
  },
  authorization: {
    notAuthorizedRoute: "You don't have the necessary entitlements to visit this route."
  },
  common: {
    or: 'Or',
    add: 'Add',
    select: 'Select',
    copied: 'Copied',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    throName: 'Technical University of Applied Sciences Rosenheim',
    companiesAndPartners: 'Companies & Partners',
    email: 'Email Address',
    email_short: 'Email',
    email_login: 'E-Mail/Login',
    enterEmail: 'Please enter email',
    enterSearchTerm: 'Please enter a search term',
    invoiceEmail: 'invoice email',
    password: 'Password',
    upload: 'Upload',
    confirmPassword: 'Confirm password',
    address: 'Address',
    phone: 'Phone',
    fax: 'Fax',
    position: 'Position',
    faculty: 'Faculty',
    faculties: 'Faculties',
    ok: 'Ok',
    companyName: 'Company name',
    name: 'Name',
    firstName: 'First name',
    lastName: 'Last name',
    street: 'Street',
    zip: 'ZIP',
    city: 'City',
    useSameAddress: 'Use company address as invoice address',
    invoiceAddress: 'Invoice Address',
    taxId: 'Value Added Tax Registration Number',
    taxNumber: 'Tax Number',
    validatingTaxId: 'Your VAT number is being verified. Please be patient for a moment.',
    failedValidatingTaxId: 'The validation of your VAT number failed! Reason: {{cause}}',
    taxId_short: 'VAT Number',
    homepage: 'Homepage',
    country: 'Country',
    contactPerson: 'Contact Person',
    description: 'Description',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    copy: 'Copy',
    reallyDelete: 'Really delete?',
    cancelEvent: 'Cancel',
    edit: 'Edit',
    register: 'Register',
    unregister: 'Unregister',
    details: 'Details',
    unlock: 'Activate',
    activate: 'Activate',
    deactivate: 'Deactivate',
    archive: 'Archive',
    ban: 'Ban',
    reject: 'Reject',
    reactivate: 'Reactivate',
    course: 'Course',
    courses: 'Courses',
    type: 'Type',
    chooseACountry: 'Choose a country',
    emptyList: 'No entries. Maybe you need to tweak the filter settings.',
    create: 'Create',
    export: 'Export',
    company: 'Company',
    companies: 'Companies',
    requiredFields: 'required fields',
    back: 'Back',
    next: 'Next',
    confirm: 'Confirm',
    period: 'Period',
    pastPeriods: 'Past Periods',
    start: 'Start',
    end: 'End',
    jobmarketAdministrator: 'Jobmarket Administrator',
    incomingsAdministrator: 'Incomings Administrator',
    incomingsUser: 'International Office Student',
    yes: 'Yes',
    no: 'No',
    confirmCancel: 'Do you really want to cancel?',
    cancelConfirm: {
      message: 'Changes will be gone. Are you sure you want to drop them?',
      title: 'Really cancel?'
    },
    title: 'Title',
    search: 'Search',
    genericError: 'Oh, something went wrong here. We will look into it, please try again later.',
    inactive: 'Inactive',
    event: 'Event',
    id: 'ID',
    userId: 'UserID',
    download: 'Download',
    import: 'Import',
    loginWithEntitlements: 'Login with selected entitlements',
    subject: 'Subject',
    html: 'HTML',
    text: 'Text',
    department: 'Department',
    semester: 'Semester',
    degree: 'Degree',
    locationOfStudy: 'Study location',
    location: 'Location',
    shorthand: 'Shorthand',
    loading: 'Loading...',
    actions: 'Actions',
    on: 'On',
    off: 'Off',
    last24h: 'Last 24 Hours',
    last3d: 'Last 3 Days',
    last7d: 'Last 7 Days',
    last14d: 'Last 14 Days',
    sortBy: 'Sort by',
    category: 'Category',
    clone: 'Clone',
    none: 'None',
    informationUnavailable: 'This information is unavailable.',
    tooManyImages: 'Only one image can be uploaded.',
    weekdays: {
      mon: 'Monday',
      tue: 'Tuesday',
      wed: 'Wednesday',
      thu: 'Thursday',
      fri: 'Friday',
      sat: 'Saturday',
      sun: 'Sunday'
    },
    weekdaysShort: {
      mon: 'Mon',
      tue: 'Tue',
      wed: 'Wed',
      thu: 'Thu',
      fri: 'Fri',
      sat: 'Sat',
      sun: 'Sun'
    },
    storno: 'Cancel',
    canceled: 'Canceled',
    alerts: {
      failedImageUpload: 'The image could not be uploaded.',
      failedFileUpload: 'The file could not be uploaded.',
      failedFileUploadWithCause: 'The file could not be uploaded. Reason: {{cause}}',
      causes: {
        tooManyTokens: 'The file is too large.'
      }
    },
    mtrNumber: 'Matriculation number',
    filter: 'Filter',
    apply: 'Apply',
    notAvailableYet: 'Not available yet',
    notAvailable: 'Not set',
    unavailable: 'Unavailable',
    netto: 'Subtotal',
    brutto: 'Total',
    ust: 'VAT',
    state: 'State',
    customer: 'Customer',
    bankAccount: 'Bank account',
    paymentTarget: 'Payment target',
    tax: 'Tax',
    amount: 'Amount',
    price: 'Price',
    singlePrice: 'Single price',
    totalPrice: 'Total price',
    addUser: 'Add user',
    unit: 'Unit',
    days: 'Days',
    close: 'Close',
    date: 'Date',
    areaCurrentlyDisabled: 'This area is currently disabled.',
    preview: 'Preview',
    accept: 'Accept',
    deny: 'Deny',
    general: 'General',
    noPermission: 'No Permission',
    expires: 'Expires on'
  },
  layout
};
export default en;
